import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '../data/seoConfig';

// BreadcrumbList + ItemList structured data for catalogue pages (SEO).
const CatalogueJsonLd = ({ currentCategory, currentSubcategory, products }) => {
  const crumbs = [
    { name: 'Accueil', path: '/' },
    { name: 'Catalogue', path: '/catalogue' },
  ];
  if (currentCategory) {
    crumbs.push({ name: currentCategory.name, path: `/catalogue/${currentCategory.slug}` });
  }
  if (currentCategory && currentSubcategory) {
    crumbs.push({
      name: currentSubcategory.name,
      path: `/catalogue/${currentCategory.slug}/${currentSubcategory.slug}`,
    });
  }

  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: SITE_URL + it.path,
    })),
  };

  const list = (products || []).slice(0, 30);
  const itemList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    numberOfItems: list.length,
    itemListElement: list.map((p, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: p.name,
      description: p.description,
      image: p.image,
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
      <script type="application/ld+json">{JSON.stringify(itemList)}</script>
    </Helmet>
  );
};

export default CatalogueJsonLd;
